// Why a publish parked, as the KG transition endpoints and the KG editor's publication API report it.
export type KgHeldReason = 'open_items' | 'node_missing' | 'node_retired';

export interface KgHoldGating {
    blocking_measure_count: number;
    open_clarifications: boolean;
    open_clarification_count?: number;
}

type HoldT = (key: string, options?: Record<string, unknown>) => string;

/** The hold line every surface renders; `params` carries the entity names a bundle may interpolate. */
export function formatHoldText(
    reason: KgHeldReason,
    gating: KgHoldGating | undefined,
    t: HoldT,
    params: Record<string, unknown> = {},
): string {
    if (reason !== 'open_items') {
        return t(reason === 'node_missing' ? 'hold_node_missing' : 'hold_node_retired');
    }
    const items: string[] = [];
    const measures = gating?.blocking_measure_count ?? 0;
    if (measures > 0) {
        items.push(t('hold_open_items_measures', { count: measures }));
    }
    if (gating?.open_clarifications) {
        items.push(t('hold_open_items_clarifications'));
    }
    if (items.length === 0) {
        items.push(t('hold_open_items_generic'));
    }
    return t('hold_open_items', { ...params, items: items.join(', ') });
}
